var map = {
	"./FlagAustralia-aodaliya.svg": "./src/icons/svg/FlagAustralia-aodaliya.svg",
	"./FlagAustria-aodili.svg": "./src/icons/svg/FlagAustria-aodili.svg",
	"./FlagAustria-oumeng.svg": "./src/icons/svg/FlagAustria-oumeng.svg",
	"./FlagBangladesh-mengjialaguo.svg": "./src/icons/svg/FlagBangladesh-mengjialaguo.svg",
	"./FlagBelgium-bilishi'.svg": "./src/icons/svg/FlagBelgium-bilishi'.svg",
	"./FlagBrazil-baxi.svg": "./src/icons/svg/FlagBrazil-baxi.svg",
	"./FlagBulgaria-baojialiya.svg": "./src/icons/svg/FlagBulgaria-baojialiya.svg",
	"./FlagCanada-jianada.svg": "./src/icons/svg/FlagCanada-jianada.svg",
	"./FlagChina-zhongguo.svg": "./src/icons/svg/FlagChina-zhongguo.svg",
	"./FlagCostaRica-gesidalijia.svg": "./src/icons/svg/FlagCostaRica-gesidalijia.svg",
	"./FlagCroatia-keluodiya.svg": "./src/icons/svg/FlagCroatia-keluodiya.svg",
	"./FlagCyprus-saipulusi.svg": "./src/icons/svg/FlagCyprus-saipulusi.svg",
	"./FlagCzech-jieke.svg": "./src/icons/svg/FlagCzech-jieke.svg",
	"./FlagDenmark-danmai.svg": "./src/icons/svg/FlagDenmark-danmai.svg",
	"./FlagEgypt-aiji.svg": "./src/icons/svg/FlagEgypt-aiji.svg",
	"./FlagEstonia-aishaniya.svg": "./src/icons/svg/FlagEstonia-aishaniya.svg",
	"./FlagFinland-fenlan.svg": "./src/icons/svg/FlagFinland-fenlan.svg",
	"./FlagFrance-faguo.svg": "./src/icons/svg/FlagFrance-faguo.svg",
	"./FlagGeorgia-gelujiya.svg": "./src/icons/svg/FlagGeorgia-gelujiya.svg",
	"./FlagGermany-deguo.svg": "./src/icons/svg/FlagGermany-deguo.svg",
	"./FlagGreece-xila.svg": "./src/icons/svg/FlagGreece-xila.svg",
	"./FlagGuatemala-weidimala.svg": "./src/icons/svg/FlagGuatemala-weidimala.svg",
	"./FlagHongKong-xianggang.svg": "./src/icons/svg/FlagHongKong-xianggang.svg",
	"./FlagHungary-xiongyali.svg": "./src/icons/svg/FlagHungary-xiongyali.svg",
	"./FlagIceland-bingdao.svg": "./src/icons/svg/FlagIceland-bingdao.svg",
	"./FlagIndia-yindu.svg": "./src/icons/svg/FlagIndia-yindu.svg",
	"./FlagIndonesia-yindunixiya.svg": "./src/icons/svg/FlagIndonesia-yindunixiya.svg",
	"./FlagIreland-aierlan.svg": "./src/icons/svg/FlagIreland-aierlan.svg",
	"./FlagIsrael-yiselie.svg": "./src/icons/svg/FlagIsrael-yiselie.svg",
	"./FlagItaly-yidali.svg": "./src/icons/svg/FlagItaly-yidali.svg",
	"./FlagJapan-riben.svg": "./src/icons/svg/FlagJapan-riben.svg",
	"./FlagLatvia-latuoweiya.svg": "./src/icons/svg/FlagLatvia-latuoweiya.svg",
	"./FlagLithuania-litaowan.svg": "./src/icons/svg/FlagLithuania-litaowan.svg",
	"./FlagLuxembourg-lusenbao.svg": "./src/icons/svg/FlagLuxembourg-lusenbao.svg",
	"./FlagMalaysia-malaixiya.svg": "./src/icons/svg/FlagMalaysia-malaixiya.svg",
	"./FlagMalta-maerta.svg": "./src/icons/svg/FlagMalta-maerta.svg",
	"./FlagMexico-moxige.svg": "./src/icons/svg/FlagMexico-moxige.svg",
	"./FlagMorocco-moluoge.svg": "./src/icons/svg/FlagMorocco-moluoge.svg",
	"./FlagNepal-niboer.svg": "./src/icons/svg/FlagNepal-niboer.svg",
	"./FlagNetherland-helan.svg": "./src/icons/svg/FlagNetherland-helan.svg",
	"./FlagNewzealand-xinxilan.svg": "./src/icons/svg/FlagNewzealand-xinxilan.svg",
	"./FlagNorway-nuowei.svg": "./src/icons/svg/FlagNorway-nuowei.svg",
	"./FlagOther.svg": "./src/icons/svg/FlagOther.svg",
	"./FlagPakistan-bajisitan.svg": "./src/icons/svg/FlagPakistan-bajisitan.svg",
	"./FlagPhilippines-feilvbin.svg": "./src/icons/svg/FlagPhilippines-feilvbin.svg",
	"./FlagPoland-bolan.svg": "./src/icons/svg/FlagPoland-bolan.svg",
	"./FlagPortugal-putaoya.svg": "./src/icons/svg/FlagPortugal-putaoya.svg",
	"./FlagRomania-luomaniya.svg": "./src/icons/svg/FlagRomania-luomaniya.svg",
	"./FlagRussia-eluosi.svg": "./src/icons/svg/FlagRussia-eluosi.svg",
	"./FlagSingapore-xinjiapo.svg": "./src/icons/svg/FlagSingapore-xinjiapo.svg",
	"./FlagSlovakia-siluofake.svg": "./src/icons/svg/FlagSlovakia-siluofake.svg",
	"./FlagSlovenia-siluowenniya.svg": "./src/icons/svg/FlagSlovenia-siluowenniya.svg",
	"./FlagSouthKorea-hanguo.svg": "./src/icons/svg/FlagSouthKorea-hanguo.svg",
	"./FlagSpain-xibanya.svg": "./src/icons/svg/FlagSpain-xibanya.svg",
	"./FlagSriLanka-sililanka.svg": "./src/icons/svg/FlagSriLanka-sililanka.svg",
	"./FlagSweden-ruidian.svg": "./src/icons/svg/FlagSweden-ruidian.svg",
	"./FlagSwitzerland-ruishi.svg": "./src/icons/svg/FlagSwitzerland-ruishi.svg",
	"./FlagTaiwan.svg": "./src/icons/svg/FlagTaiwan.svg",
	"./FlagThailand-taiguo.svg": "./src/icons/svg/FlagThailand-taiguo.svg",
	"./FlagTurkey-tuerqi.svg": "./src/icons/svg/FlagTurkey-tuerqi.svg",
	"./FlagUAE-alianqiu.svg": "./src/icons/svg/FlagUAE-alianqiu.svg",
	"./FlagUkraine-wukelan.svg": "./src/icons/svg/FlagUkraine-wukelan.svg",
	"./FlagUnitedKingdom-yingguo.svg": "./src/icons/svg/FlagUnitedKingdom-yingguo.svg",
	"./FlagUnitedStates-meiguo.svg": "./src/icons/svg/FlagUnitedStates-meiguo.svg",
	"./FlagUruguay-wulagui.svg": "./src/icons/svg/FlagUruguay-wulagui.svg",
	"./FlagVietnam-yuenan.svg": "./src/icons/svg/FlagVietnam-yuenan.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg",
	"./朝鲜.svg": "./src/icons/svg/朝鲜.svg",
	"./欧盟.svg": "./src/icons/svg/欧盟.svg",
	"./蒙古.svg": "./src/icons/svg/蒙古.svg",
	"./马其顿.svg": "./src/icons/svg/马其顿.svg",
	"./马尔代夫.svg": "./src/icons/svg/马尔代夫.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";